<template>
    <div>
        <v-container
            v-show="!loader && page.displaySubcategories"
            id="anchor-tab"
            ref="stickyAnchor"
            :class="{
                'anchortabs text-center pt-0 pb-0 bg--dkblue stickyAnchorTabs': true,
                'anchortabs--md-and-down': $vuetify.breakpoint.mdAndDown,
                'anchortabs--lg-and-up': $vuetify.breakpoint.lgAndUp,
                'fixed': isFixed
            }"
            fluid
            style="padding-left: 0; padding-right: 0"
        >
            <v-row column justify-center align-center>
                <v-col cols="12" class="pa-0 d-flex justify-center cta-links-wrapper">
                    <v-btn-toggle
                        dark
                        dense
                        group
                        tile
                        show-arrows
                        color="white"
                    >
                            <v-btn v-for="(item, i) in subcategoriesSorted"
                            :key="i" text @click="setHash(item)">
                                {{
                                    item.title && item.title[$i18n.locale]
                                        ? item.title[$i18n.locale]
                                        : 'No Title'
                                }}
                            </v-btn>
                    </v-btn-toggle>
                </v-col>
            </v-row>
        </v-container>
        <v-container id="categories-wrapper">
            <v-row column justify-center align-center no-gutters>
                <v-col cols="12">
                    <div v-if="loader">
                        <v-skeleton-loader
                            v-for="index in 10"
                            :key="index"
                            class="mx-auto mb-8"
                            max-width="100%"
                            type="card-heading,divider,list-item-three-line"
                            elevation="2"
                        ></v-skeleton-loader>
                    </div>
                    <div v-show="!loader && page.displaySubcategories">
                        <v-expansion-panels
                            v-if="
                                page.subcategories &&
                                page.subcategories.length > 0
                            "
                            v-model="allOpen"
                            :multiple="true"
                            :focusable="true"
                            :hover="true"
                            :tile="false"
                            :accordion="false"
                            :flat="true"
                        >
                            <v-expansion-panel
                                v-for="(item, i) in subcategoriesSorted"
                                :key="i"
                            >
                                <v-expansion-panel-header>
                                    <template v-slot:default="{ open }">
                                        <v-row
                                            column
                                            justify-center
                                            align-center
                                            no-gutters
                                        >
                                            <v-col cols="12"
                                                ><h2
                                                    :id="`${
                                                        item.slug &&
                                                        item.slug[
                                                            $i18n.locale
                                                        ] &&
                                                        item.slug[$i18n.locale]
                                                            .current
                                                            ? getCleanQuerySelector(
                                                                  item.slug[
                                                                      $i18n
                                                                          .locale
                                                                  ].current
                                                              )
                                                            : i
                                                    }`"
                                                    class="ma-0"
                                                >
                                                    <span>{{
                                                        item.title &&
                                                        item.title[$i18n.locale]
                                                            ? item.title[
                                                                  $i18n.locale
                                                              ]
                                                            : 'No Title'
                                                    }}</span
                                                    ><small
                                                        v-if="
                                                            page.slug.en
                                                                .current ===
                                                            'accessories-replacement-components'
                                                        "
                                                        >{{
                                                            ' - Accessories & Components'
                                                        }}</small
                                                    >
                                                </h2></v-col
                                            >
                                        </v-row>
                                    </template>
                                </v-expansion-panel-header>
                                <v-expansion-panel-content
                                    :id="`sub-category-${i}`"
                                >
                                    <Content
                                        v-if="item.contentSections"
                                        :page="item"
                                    />
                                    <FeaturedProducts
                                        :page="page"
                                        :items="
                                            sortItems(
                                                fetchProducts(item, page._id)
                                            )
                                        "
                                    />
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                        </v-expansion-panels>
                    </div>
                    <div
                        v-show="
                            !loader &&
                            !page.displaySubcategories &&
                            page.subcategories &&
                            page.subcategories.length > 0
                        "
                    >
                        <FeaturedSubcategories
                            v-if="page && page.displayOnlySubcategories"
                            :page="page"
                            :posts="page.subcategories"
                        />
                        <FeaturedProducts
                            v-else
                            :page="page"
                            :items="sortItems(fetchProducts(page, page._id))"
                        />
                    </div>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>
<script>
import Content from '~/components/Content.vue'
import FeaturedProducts from '~/components/featured/FeaturedProducts.vue'
import FeaturedSubcategories from '~/components/featured/FeaturedSubcategories.vue'
import cleanQuerySelector from '~/util/cleanQuerySelector'
export default {
    name: 'ContentCategories',
    components: {
        Content,
        FeaturedProducts,
        FeaturedSubcategories,
    },
    props: {
        page: {
            type: Object,
            default: null,
        },
        loader: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            allOpen: [...Array(this.page.subcategories.length).keys()].map(
                (k, i) => i
            ),
            subcategoriesSorted:
                this.page &&
                this.page.subcategories &&
                this.page.subcategories.length > 0
                    ? this.sortItemsAlpha(this.page.subcategories)
                    : [],
            windowTop: null,
            stickyTop: null,
            isFixed: false,
            initialTop: null,
        }
    },
    mounted() {
        window.addEventListener('scroll', this.onScroll)
        if(this.$refs['stickyAnchor'])
            this.initialTop = this.$refs['stickyAnchor'].offsetTop
    },
    computed: {
        scrollOptions() {
            return {
                duration: 1000,
                offset: 100,
                easing: 'easeInOutCubic',
            }
        },
    },
    beforeDestroy() {
        window.removeEventListener('scroll', this.onScroll)
    },
    watch: {
        '$route.hash': {
            handler: function () {
                this.handleScrollToContent()
            },
        },
    },
    methods: {
        // fetchSubcategories() {
        //     return this.sortItems(this.subcategoriesSorted)
        // },
        fetchProducts(item, pageID = null) {
            const catId = item._id
            const isAccessories =
                pageID === '57c5f7d6-4655-4b4b-8730-d7ec3cc27f98'
            return item && item.products && item.products.length > 0
                ? item.products
                      .filter((item) => {
                          const isFound = item.categories.some(
                              (i) => i._ref === catId
                          )
                          if (
                              isAccessories &&
                              isFound &&
                              item.categories &&
                              item.categories.length > 0
                          ) {
                              //   console.log('found this accessory!', item)
                              //   const accessoryFound = item.categories.filter()
                              if (
                                  item.categories.filter((cat) => {
                                      return cat._ref === pageID
                                  }).length > 0
                              ) {
                                  return item
                              }
                          } else if (isFound) {
                              return item
                          }
                      })
                      .sort((a, b) =>
                          parseInt(a.sequence) > parseInt(b.sequence) ? 1 : -1
                      )
                : []
            // return item && item.products && item.products.length > 0
            //     ? item.products
            //     : []
        },
        sortItems(items) {
            // console.log(
            //     'BEFORE',
            //     items.map((item) => {
            //         return item.title.en
            //     })
            // )
            items.sort((a, b) =>
                parseInt(a.sequence) > parseInt(b.sequence) ? 1 : -1
            )
            // console.log(
            //     'AFTER',
            //     items.map((item) => {
            //         return item.title.en
            //     })
            // )
            return items
        },
        sortItemsAlpha(items) {
            // console.log(
            //     'BEFORE',
            //     items.map((item) => {
            //         return item.title.en
            //     })
            // )
            items.sort((a, b) => (a.sequence > b.sequence ? 1 : -1))
            // console.log(
            //     'AFTER',
            //     items.map((item) => {
            //         return item.title.en
            //     })
            // )
            return items
        },
        getCleanQuerySelector(selector) {
            return cleanQuerySelector(selector)
        },
        goToSubCategory(i) {
            // console.log(i)
            return `#sub-category-${i}`
        },
        onScroll() {
            this.windowTop = window.top.scrollY;
            this.stickyTop = this.$refs['stickyAnchor'].offsetTop
            this.stickyTop = this.windowTop < 2460?this.initialTop:112
            this.isFixed =  this.windowTop > this.stickyTop?true:false
        },
        setHash(item) {
            this.$router.replace({
                path: this.$route.path,
                hash: `#${item.slug.en.current}`,
            })
        },
        handleScrollToContent() {
            const cleanHash = cleanQuerySelector(window.location.hash)
            this.$vuetify.goTo(cleanHash, this.scrollOptions)
        },
    },
}
</script>
<style scoped lang="scss">
.fixed {
    position: fixed;
}
</style>
